module.exports = __webpack_public_path__ + "img/schedule.5e0311ca.svg";